/**
 * @generated SignedSource<<e7be0a06cf0c188b898201d53cac3f3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AssignmentStatus = "ACCEPTED" | "CANCELED" | "IN_PROGRESS" | "NONE" | "NOT_STARTED" | "READY_FOR_REVIEW" | "REJECTED" | "UNDER_REVIEW" | "%future added value";
export type SubmissionStatus = "ACCEPTED" | "READY_FOR_REVIEW" | "REJECTED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DeliverTab_moduleDeliverableAsset$data = {
  readonly flow: {
    readonly assignedTo: {
      readonly firstName: string;
      readonly lastName: string;
    } | null | undefined;
    readonly assignmentStatus: AssignmentStatus;
  } | null | undefined;
  readonly galleryAssetDeliverableId: UUID | null | undefined;
  readonly moduleSubmissionsByModuleFlowId: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly submissionStatus: SubmissionStatus;
    }>;
  };
  readonly submissionLock: boolean;
  readonly tasksByModuleFlowId: {
    readonly nodes: ReadonlyArray<{
      readonly complete: boolean;
      readonly flow: {
        readonly name: string;
      } | null | undefined;
      readonly flowId: UUID;
      readonly " $fragmentSpreads": FragmentRefs<"TaskCompleteCheckbox_task">;
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"DeliverableFileUploadTable_galleryAsset" | "SubmitButton_Fragment" | "SubmittedAssetFilesDisplay_Fragment">;
  readonly " $fragmentType": "DeliverTab_moduleDeliverableAsset";
};
export type DeliverTab_moduleDeliverableAsset$key = {
  readonly " $data"?: DeliverTab_moduleDeliverableAsset$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeliverTab_moduleDeliverableAsset">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeliverTab_moduleDeliverableAsset",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Flow",
      "kind": "LinkedField",
      "name": "flow",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assignmentStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GwtUser",
          "kind": "LinkedField",
          "name": "assignedTo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submissionLock",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeliverableFileUploadTable_galleryAsset"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubmitButton_Fragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubmittedAssetFilesDisplay_Fragment"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "galleryAssetDeliverableId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "PRIORITY_ASC"
        }
      ],
      "concreteType": "TasksConnection",
      "kind": "LinkedField",
      "name": "tasksByModuleFlowId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "flowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "complete",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TaskCompleteCheckbox_task"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Flow",
              "kind": "LinkedField",
              "name": "flow",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "tasksByModuleFlowId(orderBy:\"PRIORITY_ASC\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "ATTEMPT_DESC"
        }
      ],
      "concreteType": "ModuleSubmissionsConnection",
      "kind": "LinkedField",
      "name": "moduleSubmissionsByModuleFlowId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ModuleSubmission",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "submissionStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "moduleSubmissionsByModuleFlowId(orderBy:\"ATTEMPT_DESC\")"
    }
  ],
  "type": "Module",
  "abstractKey": null
};

(node as any).hash = "663752926d9eb0ca8169453f59b50331";

export default node;
